// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t6XMiKMejy6N5m {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: 8px 12px 4px;
  margin-bottom: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"minimalCard": `t6XMiKMejy6N5m`
};
export default ___CSS_LOADER_EXPORT___;
